(function() {
'use strict';

const header = document.querySelector("#shopify-section-header");

document.addEventListener("scroll", () => {
    if (!header) return;
    if (window.scrollY > 20) {
        header.classList.add("pf-header-fix");
        const navigationBarPDP = document.querySelector("#sticky-navigation-pdp");
        if (navigationBarPDP) {
            navigationBarPDP.classList.add("pf-header-fix");
        }
    } else {
        header.classList.remove("pf-header-fix");
        const navigationBarPDP = document.querySelector("#sticky-navigation-pdp");
        if (navigationBarPDP) {
            navigationBarPDP.classList.remove("pf-header-fix");
        }
    }
});

function BlockScroll() {
    document.querySelector("html").classList.add("scroll-block");
}

function AllowScroll() {

    document.querySelector("html").classList.remove("scroll-block");

}

const menuObserver = new MutationObserver(() => {
    const body = document.querySelector("body");
    if (body.classList.contains("nav-active")) {
        BlockScroll();
    } else {
        AllowScroll();
    }
});

const cartObserver = new MutationObserver(() => {
    const cart = document.querySelector(".rc90");
    if (!cart) return;
    if (cart.classList.contains("rc90--open")) {
        BlockScroll();
    } else {
        AllowScroll();
    }
});

const cart = document.querySelector(".rc90");
if (cart) {
    cartObserver.observe(cart, {
        attributes: true,
        attributeFilter: ["class"],
    });
}

const body = document.querySelector("body");
if (body) {
    menuObserver.observe(body, {
        attributes: true,
        attributeFilter: ["class"],
    });
}

})();
